$(document).ready(function() {
  
  
  
$('.rdcimageslidescon').slick({
dots: false,
infinite: true,
speed: 500,
slidesToShow: 1,
slidesToScroll: 1,
autoplay: true,
autoplaySpeed: 2000,
arrows: false

});
  
    
// Show the first tab content and hide the rest
  $('.rdcchooseyourcolorimgsinner:first-child').addClass('active');
$('.rdcchooseyourcolorimg').hide();
  $('.rdcchooseyourcolorimg:first').show();

// Click function
$('.rdcchooseyourcolortabs .cycbtncon').click(function(){
  $('.rdcchooseyourcolortabs .cycbtncon').removeClass('active');
  $(this).addClass('active');
  $('.rdcchooseyourcolorimg').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});
  
  
if ($(window).width() > 1199) {
  $('.rdcchooseyourcolortabsinner').slick({
dots: false,
infinite: true,
speed: 3000,
slidesToShow: 12,
slidesToScroll: 1,
autoplay: true,
autoplaySpeed: 1000,
arrows: true

});
  }
  

       if ($(window).width() < 769) {
  $('.rdcchooseyourcolortabsinner').slick({
dots: false,
infinite: true,
speed: 3000,
slidesToShow: 4,
slidesToScroll: 4,
autoplay: true,
autoplaySpeed: 1000,
arrows: true

});
  }
  
  if ($(window).width() < 1200) {
  $('.rdcchooseyourcolortabsinner').slick({
dots: false,
infinite: true,
speed: 3000,
slidesToShow: 6,
slidesToScroll: 3,
autoplay: true,
autoplaySpeed: 1000,
arrows: true

});
  }
  
 
  

  
  
});

